import Vue from 'vue';
import VueHeadful from 'vue-headful';


Vue.component('vue-headful', VueHeadful);